import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {PlatformToolNewsletterContentComponent} from '@features/newsletter/components/platform-tool-newsletter-content/platform-tool-newsletter-content.component';
// @dynamic
export class NewsletterDynamicComponentHelper {
  public static components: any;
  public static init () {
    if (NewsletterDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['PlatformToolNewsletterContentComponent'] = PlatformToolNewsletterContentComponent;
    NewsletterDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray (): any[] {
    NewsletterDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(NewsletterDynamicComponentHelper.components).forEach(key => {
      componentArray.push(NewsletterDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }

  public static register(key: string, component: any) {
    NewsletterDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
